import httpHandler, { RequestType } from '../../services/apiService';
import apiMap from '../../utils/apiMap';
import { store } from '../../utils/userStore';
import {
  ExitedSmallcaseData,
  ExitedSmallcasesResponse,
} from '../../types/apiResponses/exitedSmallcase';
import { isSdkReady } from '../../utils/sdkReadiness';

/**
 * @returns {Promise<Object>} investedSmallcase
 */

const getExitedSmallcases = function exited() {
  return isSdkReady()
    .then(() =>
      httpHandler<ExitedSmallcasesResponse>(
        RequestType.GET,
        apiMap.EXITED,
        store.gateway,
      ),
    )
    .then(({ data }) =>
      data.map((smallcase: ExitedSmallcaseData) => ({
        ...smallcase,
        imageUrl: `https://assets.smallcase.com/images/smallcases/200/${smallcase.scid}.png`,
      })),
    );
};

export default getExitedSmallcases;
